import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared/shared.module";
import { QuoteAcceptAndOrderComponent } from "./quote-accept-and-order/quote-accept-and-order.component";
import { QuoteCompletePaymentProfileComponent } from "./quote-complete-payment-profile/quote-complete-payment-profile.component";
import { QuoteFinancialsComponent } from "./quote-financials/quote-financials.component";
import { QuoteFocusLogoComponent } from "./quote-focus-logo/quote-focus-logo.component";
import { QuoteFooterComponent } from "./quote-footer/quote-footer.component";
import { QuoteHeaderComponent } from "./quote-header/quote-header.component";
import { QuoteLineItemsComponent } from "./quote-line-items/quote-line-items.component";
import { QuoteNewSystemTermsComponent } from "./quote-new-system-terms/quote-new-system-terms.component";
import { QuotePaymentProcessingRatesComponent } from "./quote-payment-processing-rates/quote-payment-processing-rates.component";
import { QuoteTermsAndConditionsComponent } from "./quote-terms-and-conditions/quote-terms-and-conditions.component";
import { QuoteViewerRoutingModule } from "./quote-viewer-routing.module";
import { QuoteViewerComponent } from "./quote-viewer.component";

@NgModule({
	declarations: [
		QuoteViewerComponent,
		QuoteLineItemsComponent,
		QuoteTermsAndConditionsComponent,
		QuotePaymentProcessingRatesComponent,
		QuoteHeaderComponent,
		QuoteFooterComponent,
		QuoteFinancialsComponent,
		QuoteNewSystemTermsComponent,
		QuoteAcceptAndOrderComponent,
		QuoteCompletePaymentProfileComponent,
		QuoteFocusLogoComponent,
	],
	imports: [SharedModule, QuoteViewerRoutingModule],
})
export class QuoteViewerModule {}
